import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client from '../contenful/client';
import Nav from '../components/Nav';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';
import aboutlogo from '../images/aboutLogo.png';
import '../pages/Project.css';

const Project = () => {
  const [projects, setProjects] = useState([]);
  const [activeButton, setActiveButton] = useState('SELECTED');

  // useEffect(() => {
  //   client.getEntries({ content_type: 'projects' })
  //     .then(res => setProjects(res.items))
  //     .catch(console.error);
  // }, []);
  useEffect(() => {
    client
      .getEntries({ content_type: 'projects' })
      .then(res => {
        // Sort by sortIndex (default 0 if not present)
        const sorted = res.items.sort((a, b) => {
          return (a.fields.sortIndex || 0) - (b.fields.sortIndex || 0);
        });

        // Debugging: log all fields for each project
        sorted.forEach(item => {
          console.log('---- Project ----');
          Object.keys(item.fields).forEach(key => {
            console.log(`${key}:`, item.fields[key]);
          });
        });

        setProjects(sorted);
      })
      .catch(console.error);
  }, []);


  // Filter logic
  const filtered = projects.filter(item => {
    if (activeButton === 'SELECTED') return true; // Show all
    return (
      item.fields.category &&
      item.fields.category.toLowerCase() === activeButton.toLowerCase()
    );
  });
  return (
    <>
      <Nav logo={aboutlogo} hamburgerColor='black' logoSize="300px" className="static-nav" />
      <div className="btn-sec">
        {['SELECTED','ARCHITECTURE','INTERIOR','COMMERCIAL'].map(cat => (
          <button
            key={cat}
            className={activeButton === cat ? 'active' : ''}
            onClick={() => setActiveButton(cat)}
          >{cat}</button>
        ))}
      </div>

      <div className="projects-sec">
        {filtered.map(item => {
          const grids = item.fields.selectedGrids || [];
          return grids.map((g, idx) => {
            if (!g?.fields?.file?.url) return null;
            console.log('Rendering project:', {
              title: item.fields.title,
              slug: item.fields.slug,
            });
            
            return (
              // In your Projects.jsx page
              <Gallery
              key={`${item.sys.id}-${idx}`}
              image={`https:${g.fields.file.url}`}
              title={g.fields.title || item.fields.title || 'Untitled'}
              link={`/projects/${item.fields.slug}`}
              state={{ project: item, allProjects: projects }}
            />
            
            

            );
          });
        })}
      </div>
      <Footer />
    </>
  );
};

export default Project;
